import { Box } from '@mui/material';
import { useAppSelector } from '../../../redux/ReduxHooks';
import { Graph } from '../dashboardTypes';
import BarGraph from '../../Graphs/BarGraph';
import type { ChartSeriesLabelOptions } from '../../Graphs/chartSeriesLabel';
import { GraphNoDataMessage } from '../../Graphs/GraphNoDataMessage';

interface BarGraphWidgetProps {
  graph: Graph | undefined;
  chartSeriesLabelOptions?: ChartSeriesLabelOptions;
}

const BarGraphWidget = ({ graph, chartSeriesLabelOptions }: BarGraphWidgetProps) => {
  const runDate = useAppSelector((state) => state.application.runDate);

  return (
    <Box className="widget-body" flex="1" overflow="hidden" display="flex">
      {graph ? <BarGraph graph={graph} chartSeriesLabelOptions={chartSeriesLabelOptions} key={`${graph?.key}_${runDate}`} /> : <GraphNoDataMessage />}
    </Box>
  );
};

export default BarGraphWidget;
